import Box from 'UIKit/Box/Box'
import Modal, { ModalBody, ModalHeader, ModalProps } from 'UIKit/Modal'
import Text from 'UIKit/Text'
import { ICommonBonus } from 'config/types/bonus'
import { UserBonus } from 'config/types/bonus/userBonus'

import { useUserTotalBalance } from 'hooks/useUserTotalBalance'
import { RowCenter } from 'layout/Components/Row'
import { useState } from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import RedeemBonusAction from 'views/FreeBonuses/components/RedeemBonusAction'
import BonusDetailsAction from './BonusDetailsAction'
import BonusDetailsContent from './BonusDetailsContent'

interface BonusDetailModalProps {
  isRedeemed?: boolean
  isClaimable?: boolean
  isExpired?: boolean
  bonus: ICommonBonus
  actionContent?: string
  percent?: number
  onBonusUpdate?: (bonus: UserBonus) => void
  onRedeemBonus?: () => Promise<boolean>
}

const BonusDetailsModal: React.FC<ModalProps<BonusDetailModalProps>> = ({ data, onDismiss }) => {
  const { onBonusUpdate = () => {}, bonus, onRedeemBonus, percent = 0 } = data
  const [bonusInstance, setBonusInstance] = useState({ instance: bonus })

  const userTotalBalance = useUserTotalBalance()
  const minBalanceToRedeem = bonus?.condition?.minBalanceToRedeem

  return (
    <StyledModal onDismiss={onDismiss} maxWidth="440px">
      <ModalHeader>
        <Box width="100%" pl={30} pr={20}>
          <Text fontSize="16px" bold>
            <Trans>Bonus Details</Trans>
          </Text>
        </Box>
      </ModalHeader>

      <StyledModalBody p={['12px 0px', '', '24px 0px']} overflowX="hidden" position="relative">
        <BonusDetailsContent bonus={bonusInstance.instance} />

        {bonusInstance.instance instanceof UserBonus ? (
          <BonusDetailsAction
            bonus={bonusInstance.instance}
            setBonusInstance={setBonusInstance}
            onDismiss={onDismiss}
            onBonusUpdate={onBonusUpdate}
          />
        ) : (
          onRedeemBonus && (
            <StyledBonusAction>
              <RedeemBonusAction
                redeemBonus={onRedeemBonus}
                isRedeemed={data?.isRedeemed}
                isClaimable={data?.isClaimable}
                isExpired={data?.isExpired}
                percent={percent}
                isNotEnoughBalanceRequirement={minBalanceToRedeem > 0 && userTotalBalance.lt(minBalanceToRedeem)}
              />
            </StyledBonusAction>
          )
        )}
      </StyledModalBody>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  ${({ theme: { mediaQueries } }) => mediaQueries.sm} {
    min-width: 420px;
    max-width: 420px;
    min-height: 576px;
    border-radius: ${({ theme }) => theme.radii.large};
  }
`

const StyledModalBody = styled(ModalBody)`
  max-height: calc(var(--screen-height) - 60px);
  box-sizing: border-box;
`

const StyledBonusAction = styled(RowCenter)`
  button {
    height: 44px !important;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    max-width: 292px;

    &:disabled {
      background: #1d2533 !important;
    }
  }
`

export default BonusDetailsModal
